
export enum TransportsTypes {
    ONIBUS = 0,
    CARRO = 1,
    METRO = 2,
    TAXIORUBER = 3,
}
export enum ClientEmployeeStatus {
    INACTIVE = 0,
    ACTIVE = 1,
}
export enum ScreensClientEmployeeUse {
    CLIENT = 'client',
    EMPLOYEE = 'employee',
}